<div class="container">
  <div class="row">
    <div class="col-md-8 col-lg-6 mx-auto">
      <div class="another-way-login">
        <div class="main-text">
          You have reached the maximum number of attempts.
          <br> Please email support (help@{{domain}}) or
          <br> call us on {{phone}}
        </div>
        <div class="return-login">
          <a routerLink="/auth/login" class="link return-login-link">Return to log in</a>
        </div>
      </div>
    </div>
  </div>
</div>